import styled, { css } from 'styled-components';
import { animationPop } from '../../../../utils/animations';
export var HeartAction = styled.div.withConfig({
  displayName: "Like__HeartAction",
  componentId: "sc-13ekdun-0"
})(["display:inline;cursor:pointer;svg{fill:", ";stroke:", ";", "}"], function (_ref) {
  var theme = _ref.theme,
    active = _ref.active;
  return active ? theme.colors.secondaryD : '#fff';
}, function (_ref2) {
  var theme = _ref2.theme,
    active = _ref2.active;
  return active ? theme.colors.secondaryD : theme.colors.font;
}, function (_ref3) {
  var active = _ref3.active;
  return active && css(["", ";"], animationPop);
});
export var LikeContainer = styled.span.withConfig({
  displayName: "Like__LikeContainer",
  componentId: "sc-13ekdun-1"
})(["display:inline;float:right;margin-left:16px;"]);